module.exports = __webpack_public_path__ + "static/img/logo.d1174c70.png";